import { useEffect } from 'react';

interface UseKeyboardNavigationProps {
  isViewerOpen: boolean;
  showPreviousImage: () => void;
  showNextImage: () => void;
  closeImageViewer: () => void;
}

export const useKeyboardNavigation = ({ isViewerOpen, showPreviousImage, showNextImage, closeImageViewer }: UseKeyboardNavigationProps) => {
  useEffect(() => {
    if (!isViewerOpen) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      // on press left arrow
      if (event.key === 'ArrowLeft') showPreviousImage();
      // on press right arrow
      if (event.key === 'ArrowRight') showNextImage();
      // on press escape
      if (event.key === 'Escape' || event.key === 'Esc') closeImageViewer();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isViewerOpen, showPreviousImage, showNextImage]);
};
